export var DEFAULT_BREAK_POINT = 'medium';

export default function isResponsiveAndOverBreakPoint(browser, responsiveDrawer, breakPoint) {
  return browser.greaterThan[breakPoint !== undefined ? breakPoint : DEFAULT_BREAK_POINT] && responsiveDrawer.responsive;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-responsive-drawer/es/store/selectors.js
// module id = XGR7
// module chunks = 0